import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Box, Typography, Paper } from "@mui/material";
import { Message } from "@mui/icons-material";
import { ColorsConstants } from "../../../cssUtils/constants";
import { formatTitle, getNodeColor, nodeIcons } from "./utils";

const CustomNode = ({ data, selected }) => {
  const Icon = nodeIcons[data.category] || Message;
  const color = getNodeColor(data.category, data.node_type_key);
  
  const tags = data?.tags || [];
  const templates = data?.templates || [];

  const get_selected_tag_names = (tagIds) => {
    const selectedTags = tags.filter((tag) => tagIds.includes(tag.id));
    return selectedTags.map((tag) => tag.name).join(", ");
  };

  const get_template_name = (templateId) => {
    const selectedTemplate = templates.find(
      (template) => template.template_id === templateId,
    );
    return selectedTemplate?.template_name || "";
  }

  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: 2,
        minWidth: 180,
        maxWidth: 280,
        border: selected ? `2px solid ${color}` : "1px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "white",
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          boxShadow: 4,
        },
      }}
    >
      {data.category !== "start" && (
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: color,
            width: 10,
            height: 10,
          }}
        />
      )}

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Icon sx={{ color, fontSize: 20 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color }}>
          {formatTitle(data.label)}
        </Typography>
      </Box>

      {data.description && (
        <Typography
          variant="caption"
          sx={{
            color: ColorsConstants.primaryGray60,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            fontSize: "0.7rem",
          }}
        >
          {data.description}
        </Typography>
      )}

      {data.node_type_key === "compare_tag" &&
        (data?.config?.tags?.length > 0 ? (
          <Typography
            variant="caption"
            sx={{
              color: ColorsConstants.primaryGray60,
              display: "block",
              mt: 1,
            }}
          >
            <strong>Selected Tags:</strong>{" "}
            {get_selected_tag_names(data?.config?.tags)}
          </Typography>
        ) : (
          <Typography
            variant="caption"
            sx={{
              color: ColorsConstants.primaryGray60,
              display: "block",
              mt: 1,
            }}
          >
            <strong>No Tags Selected</strong>
          </Typography>
        ))}

      {data.node_type_key === "schedule_template_message" &&
        (data?.config?.template_id ? (
          <Typography
            variant="caption"
            sx={{
              color: ColorsConstants.primaryGray60,
              display: "block",
              mt: 1,
            }}
          >
            <strong>Selected Template:</strong>{" "}
            {get_template_name(data?.config?.template_id)}
          </Typography>
        ) : (
          <Typography
            variant="caption"
            sx={{
              color: ColorsConstants.primaryGray60,
              display: "block",
              mt: 1,
            }}
          >
            <strong>No Template Selected</strong>
          </Typography>
        ))}

      {data.node_type_key === "otp_select_template" && (
        <Typography
          variant="caption"
          sx={{
            color: ColorsConstants.primaryGray60,
            display: "block",
            mt: 1,
          }}
        >
          <strong>{data?.config?.template_name ? "Selected Template:" : "No Template Selected"}</strong>{" "}
          {data?.config?.template_name || ""}
        </Typography>
      )}

      {data.category !== "end" && (
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: color,
            width: 10,
            height: 10,
          }}
        />
      )}
    </Paper>
  );
};

export default CustomNode;
